// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2skuE","requiredAsterisk":"Info_requiredAsterisk__3dDez"};